import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCarFrontView: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="car-front-view"><path d="M2.75 19.25V11L7 4.75H17L21.25 11V19.25H17.25V17.1786H6.75V19.25H2.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M1 10.25H3" stroke="currentColor" strokeWidth="1.5"/><path d="M21 10.25H22.9998" stroke="currentColor" strokeWidth="1.5"/><path d="M5 13.25H8" stroke="currentColor" strokeWidth="1.5"/><path d="M16 13.25H19" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCarFrontView;
